var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Desktop-Dollar--Streamline-Core.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Desktop Dollar Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desktop-dollar--cash-desktop-display-device-notification-computer-money-currency"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M1.5 1A1.5 1.5 0 0 0 0 2.5v7A1.5 1.5 0 0 0 1.5 11h3.985l-0.537 1.5H4A0.75 0.75 0 0 0 4 14h6a0.75 0.75 0 0 0 0 -1.5h-0.948L8.515 11H9a1 1 0 1 0 0 -2H2V3h5a1 1 0 0 0 0 -2H1.5Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M11.583 0a0.75 0.75 0 0 1 0.75 0.75v0.528a1.999 1.999 0 0 1 1.553 1.305 0.75 0.75 0 0 1 -1.414 0.5A0.498 0.498 0 0 0 12 2.75h-0.967a0.366 0.366 0 0 0 -0.079 0.723l1.473 0.322a2 2 0 0 1 -0.094 3.927v0.528a0.75 0.75 0 0 1 -1.5 0v-0.528a2.003 2.003 0 0 1 -1.552 -1.305 0.75 0.75 0 0 1 1.414 -0.5 0.5 0.5 0 0 0 0.472 0.333H12a0.5 0.5 0 0 0 0.107 -0.99l-1.473 -0.322a1.866 1.866 0 0 1 0.2 -3.677V0.75a0.75 0.75 0 0 1 0.75 -0.75Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopDollarIcon);
export default __webpack_public_path__ + "static/media/desktop-dollar-icon.94347abd143edde97c67e4e6af18dca8.svg";
export { ForwardRef as ReactComponent };